import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
    selector: 'app-handle500dialog',
    templateUrl: './handle500dialog.component.html',
    styleUrls: ['./handle500dialog.component.scss'],
    standalone: true,
    imports: [MatDialogModule, MatIconModule]
})
export class Handle500dialogComponent {

  reloadWindow() {
    window.location.reload();
  }

}
